import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import Perk from '../components/Perk'
import Button from '../../../elements/Button'
import styles from './styles.module.scss'
import IconMore from '/public/icons/icon-more.svg'
import IconExternal from '/public/icons/icon-external.svg'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { useAuthContext } from '/providers/authProvider'
import { useState, useRef } from 'react'
import { withModifiers } from '/components/helpers/withModifiers'
import isEmpty from 'lodash-es/isEmpty'
import some from 'lodash-es/some'
import sum from 'lodash-es/sum'
import Scroll from 'react-scroll'
import { useRouter } from 'next/router'

const Amenities = ({ property, translations }) => {
  const { isTablet, isSmallMobile, isDesktop } = useResponsive()
  const router = useRouter()
  const [show, setShow] = useState(false)
  const ref = useRef(null)
  const scroll = Scroll.animateScroll
  const { isAuthorized } = useAuthContext()

  let totalAmenities = 0
  const total =
    property.amenities &&
    property.amenities?.map(
      (item) => (item && item?.perks && item?.perks?.length) || 0
    )
  totalAmenities = sum(total)

  const amenities = property.amenities && [...property.amenities]
  const firstAmenitiesColumn =
    amenities && amenities.slice(0, amenities.length / 2 - 1)
  const secondAmenitiesColumn =
    amenities && amenities.slice(amenities.length / 2 - 1)

  const emptyAmenities = isEmpty(property.amenities)

  const executeScroll = () => {
    scroll.scrollTo(
      ref.current?.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        250
    )
  }

  if (emptyAmenities) {
    return
  }

  return (
    <Section
      className={styles.amenities}
      variant={['white', !isTablet && 'pb0', isTablet && 'o-hidden']}
    >
      <Container className={styles.amenities__content}>
        <div ref={ref}>
          <h2>{translations.title[router.locale]}</h2>

          <div className={styles.amenities__container}>
            <Columns>
              <Column variant={[isDesktop && '-pr0']} spans={isTablet ? 12 : 6}>
                <Columns variant={[isSmallMobile && '-align-center']}>
                  <Column spans={isSmallMobile ? 8 : 6}>
                    {firstAmenitiesColumn.map((item, index) => (
                      <Perk
                        key={`amenity-${index}`}
                        variant={['spacing-xs']}
                        title={item.title}
                        icon={item.cloudflare_icon || item.icon}
                      >
                        <ul className="ul">
                          {item.perks.map(
                            (perk, number) =>
                              perk.priority && (
                                <li key={`${item.title}-perk-${number}`}>
                                  {perk.name}
                                </li>
                              )
                          )}
                        </ul>

                        {some(item.perks, function (topic) {
                          return !topic.priority
                        }) && (
                          <div
                            className={withModifiers(
                              'amenities__hidden',
                              [show && 'is-visible'],
                              styles
                            )}
                          >
                            <ul className="ul">
                              {item.perks.map(
                                (perk, number) =>
                                  !perk.priority && (
                                    <li key={`${item.title}-perk-${number}`}>
                                      {perk.name}
                                    </li>
                                  )
                              )}
                            </ul>
                          </div>
                        )}
                      </Perk>
                    ))}
                  </Column>
                  <Column spans={isSmallMobile ? 8 : 6}>
                    {secondAmenitiesColumn.map((item, index) => (
                      <Perk
                        key={`amenity-${index}`}
                        variant={['spacing-xs']}
                        title={item.title}
                        icon={item.cloudflare_icon || item.icon}
                      >
                        <ul className="ul">
                          {item.perks.map(
                            (perk, number) =>
                              perk.priority && (
                                <li key={`${item.title}-perk-${number}`}>
                                  {perk.name}
                                </li>
                              )
                          )}
                        </ul>

                        {some(item.perks, function (topic) {
                          return !topic.priority
                        }) && (
                          <div
                            className={withModifiers(
                              'amenities__hidden',
                              [show && 'is-visible'],
                              styles
                            )}
                          >
                            <ul className="ul">
                              {item.perks.map(
                                (perk, number) =>
                                  !perk.priority && (
                                    <li key={`${item.title}-perk-${number}`}>
                                      {perk.name}
                                    </li>
                                  )
                              )}
                            </ul>
                          </div>
                        )}
                      </Perk>
                    ))}
                  </Column>
                </Columns>
              </Column>
            </Columns>
          </div>

          <div>
            {totalAmenities !== 0 && (
              <Button
                variant={['color-primary', 'xl']}
                className={styles.amenities__button}
                appendIcon={
                  <IconMore
                    className={withModifiers(
                      'amenities__more',
                      [show && 'collapse'],
                      styles
                    )}
                    width={21}
                  />
                }
                arrow={false}
                onClick={() => {
                  executeScroll()

                  setTimeout(() => setShow(!show), 450)
                }}
              >
                {show
                  ? translations.collapse[router.locale]
                  : `${translations.show[router.locale]} ${totalAmenities} ${
                      translations.amenties[router.locale]
                    }`}
              </Button>
            )}
          </div>

          {isAuthorized && property?.attachment?.amenities && (
            <Button
              href={property.attachment.amenities}
              appendIcon={<IconExternal />}
              target="_blank"
              variant={['primary-blue', 'm-t-xl']}
            >
              {translations.download[router.locale]}
            </Button>
          )}
        </div>
      </Container>
    </Section>
  )
}

export default Amenities
